"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.logLevelParser = void 0;
const api_logs_1 = require("@opentelemetry/api-logs");
function logLevelParser(level) {
    switch (level) {
        case "ERROR":
            return api_logs_1.SeverityNumber.ERROR;
        case "WARN":
            return api_logs_1.SeverityNumber.WARN;
        case "INFO":
            return api_logs_1.SeverityNumber.INFO;
        default:
            return api_logs_1.SeverityNumber.UNSPECIFIED;
    }
}
exports.logLevelParser = logLevelParser;
//# sourceMappingURL=logLevelParser.js.map